import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import PostListItem from './PostListItem';

// The PostsList iterates over all of the players and creates
// a link to their profile page.
class PostsList extends Component {
  componentDidMount() {
    if (this.props.postType === 'Projects') {
      this.props.loadData('/data/project_data.json', 'projects'); // put project data in state on App
    }
    if (this.props.postType === 'BlogPosts') {
      this.props.loadData('/data/blog_data.json', 'blogPosts'); // put blog data in state on App
    }

    if (this.props.postType === 'Projects') {
      localStorage.setItem(`visited-${window.location.pathname}`, true); // should set inside history listen? https://github.com/ReactTraining/react-router/issues/3554
    }
  }


  render() {
    const postSection = this.props.postType === 'Projects' ? 'play' : 'bits';
    return (
      <div>
        <ul className="post-list">
          {
              this.props.posts.map((post, projectIndex) =>
                // if (this.props.postType === 'Projects' || this.props.location.pathname !== `/${postSection}/${post.slug}`) { // for BlogPosts, don't render post link if already on that posts page
                   (
                     <PostListItem key={post.slug} post={post} postSection={postSection} postType={this.props.postType} projectIndex={projectIndex} />
                  ), // end return
                // } // end if
              ) // end map
            }
        </ul>

      </div>
    );
  }
}

PostsList.propTypes = {
  posts: PropTypes.arrayOf(PropTypes.object).isRequired,
  loadData: PropTypes.func.isRequired,
  postType: PropTypes.string.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

export default withRouter(PostsList);



// WEBPACK FOOTER //
// ./src/components/PostsList.js